import { render, staticRenderFns } from "./DepositForm.vue?vue&type=template&id=ba52b288&scoped=true"
import script from "./DepositForm.vue?vue&type=script&lang=js"
export * from "./DepositForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba52b288",
  null
  
)

export default component.exports